<template>
    <div class="main">

        <c-panel>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Relatórios</label>
                    <el-select v-model="tipo">
                        <el-option :key="1" label="RELATÓRIO INSCRITOS PRÉ-MATRÍCULA ONLINE" :value="1"></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </c-panel>

        <div class="u-mt-10">
            <inscritos v-if="tipo == 1"></inscritos>
        </div>
        
    </div>
</template>
<script>

import inscritos from "./inscritos"

export default {
    data: () => ({
        tipo: 1        
    }),
    mounted () {

    },
    methods: {     
        text(){

            
        }
    },
    components:{ inscritos }
}
</script>